import { VyStack } from '@vy/ui-design-system';
import { DiscountSection, ProductSettingsSection, SchedulingSection, UpgradeOptionsSection } from '../sections';

export function TieredSubscriptionVariant() {
  return (
    <VyStack sx={{ gap: 2.5 }}>
      <ProductSettingsSection showAutomaticUpgrade showPayInAdvanceOnTierCross />
      <DiscountSection />
      <SchedulingSection showCadence showPaymentTerm />
      <UpgradeOptionsSection />
    </VyStack>
  );
}
